<template>
  <header>
    <div class='inner'>
      <nav id='nav'>
        <router-link to="/"  class="brand">Naminus</router-link>

        <span class='err' v-if="hasError"> {{ error }} </span>

        <button type='button' class='triplebar'>
          <span class='bars'></span>
        </button>
        <div class='menu'>
          <div class='items'>
            <router-link to="/" class="menu-item" exact-active-class="nav-active-link">Home</router-link>
            <router-link to="/wall" class="menu-item" exact-active-class="nav-active-link">Wall of Love ❤️</router-link>
            <router-link to="/faq" class="menu-item" exact-active-class="nav-active-link">FAQ️</router-link>
            <router-link to="/about" class="menu-item" exact-active-class="nav-active-link">About</router-link>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'Header',

    computed: {
      hasError: function(){
        return this.$store.getters.error !== "";
      },

      error: function () {
        return this.$store.getters.error;
      }
    },
  }
</script>